/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Calc_Copilot_DescInputs */



/**
* | output |
* | --- |
* | "EU AI Act risk detection per user" |
*
* @param {Cost_Calc_Copilot_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_copilot_desc = /** @type {((inputs?: Cost_Calc_Copilot_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Copilot_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("EU-AI-Act-Risikoerkennung pro Nutzer")
	return /** @type {LocalizedString} */ ("EU AI Act risk detection per user")
});